import { portalRoutes } from './portal';
import {adminRoutes} from "./admin";
import { employeeRoutes } from './employee';

export const routes = [
	...portalRoutes,
	...adminRoutes,
    ...employeeRoutes
];
